<div class='not-found-content'>
  <h1>404</h1>
  <h2>Pagina nu a fost gasită!</h2>
  <p>Din păcate, pagina pe care o cauți nu există.</p>
  <button type='button' pButton
          [label]="'Întoarce-te la pagina principală'"
          (click)='goToFunds()'
          class='button-ipensii'></button>
</div>
